const cancel = 'Скасувати'
const save = 'Зберегти'

export default {

  global: {
    generalError: 'Ой, лишенько! Запит не може бути опрацьований. Будь ласка, перезавантажте сторінку.',
    signature: 'З повагою,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Додайте резюме або інші вкладення',
      placeholderWithDescription: 'Додайте необхідні вкладення',
      remove: 'Видалити',
      allowedFileTypes: 'Дозволені типи файлів',
      errors: {
        size: 'Файл завеликий, максимальний розмір файлу - 5 МБ.',
        empty: 'Файл не містить даних',
        invalidType: fileType => `На жаль, файли ${fileType} заборонені з міркувань безпеки`,
        typeNotWhitelisted: 'На жаль, цей тип файла не дозволяється.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Політикою конфіденційності',
      termsLinkText: 'Положення та умови',
      privacyPolicyText:
        'Ми цінуємо вашу конфіденційність. Будь ласка, ознайомтеся з нашою ',
      termsText1: 'Прочитайте і прийміть ',
      termsText2: 'перш ніж надати нам свої персональні дані.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Якщо ви не хочете, щоб ми обробляли ваші особисті дані, ви можете попросити їх видалити, надіславши нам повідомлення на адресу ${mail}.`,
      customSupportPrivacyInfo: link => `Якщо ви не хочете, щоб ми обробляли ваші персональні дані, то можете попросити про їхнє видалення, зв'язавшись із ${link}.`,
    },

    buttons: {
      close: 'Закрити',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Видалити відео',
      confirm: 'Спробувати знову',
    },

    confirmButton: {
      wait: count => `Зачекати ${count}`,
      confirm: 'Підтвердити',
    },

    controlStatus: {
      text: {
        empty: 'Заповнити',
        valid: () => 'Готово',
      },
      textarea: {
        empty: 'Заповнити',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Встановити',
        valid: () => 'Готово',
      },
      file: {
        empty: 'Вибрати',
        valid: () => 'Змінити',
      },
      list: {
        empty: 'Додати',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Пошук',
        valid: () => 'Готово',
      },
    },

    cookieConsentModal: {
      title: 'Наш веб-сайт використовує файли cookie',
      body: 'Приймаючи всі файли cookie, ви погоджуєтеся зберегти їх на вашому пристрої. щоб покращити навігацію по сайту, аналізувати використання сайту та допомогти у галузі маркетингу.',
      learnMoreLinkText:
        'Дізнатися більше про те, як ми використовуємо файли cookies',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Керувати файлами cookie',
      acceptAll: 'Прийняти всі файли cookie',
      manageTitle: 'Керувати налаштуваннями згоди',
      necessaryCookiesTitle: 'Необхідні файли cookies',
      necessaryCookiesBody:
        'Ці файли cookie необхідні для функціонування веб-сайту, їх не можна вмикати в наших системах.',
      performanceCookiesTitle: 'Функціональні файли cookie',
      performanceCookiesBody:
        'Ці файли cookie дають нам змогу підраховувати відвідування та джерела трафіку, щоб виміряти та покращити ефективність нашого сайту.',
      confirmChoices: 'Підтвердьте мій вибір',
      marketingCookiesTitle: 'Маркетингові файли cookie',
      marketingCookiesBody:
        'Ці файли cookie дають нам змогу персоналізувати рекламу та вимірювати ефективність реклами.',
      functionalCookiesTitle: 'Функціональні файли cookie',
      functionalCookiesBody:
        'Ці файли cookie використовуються, щоб покращити функціональність веб-сайту. Певні функції можуть стати недоступними без цих файлів cookie. Наприклад, функціональними файлами cookie можуть бути служби веб-чату та налаштування користувача.',
    },

    emailAddresses: {
      remove: 'Видалити',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Заборонено',
      content: 'Наш сервер ввічливо (але рішуче) відмовився виконувати запит, зроблений вашим браузером. Зверніть увагу, що Recright потрібно використовувати на одному пристрої/браузері (одночасно).',
      link: 'Головна сторінка',
    },

    error404: {
      heading: 'Тут нічого немає',
      content: 'Ми пильно шукали, але за адресою, яку ви надали, немає веб-сторінки. Можливо ви перейшли за неробочим посиланням або випадково набрали неправильну адресу.',
      link: 'Головна сторінка',
    },

    error410: {
      heading: 'Закрито',
      content: 'Ви не можете переглянути посаду, оскільки вона закрита або термін подання заявки закінчився.',
      link: 'Головна сторінка',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Ініціалізація…',
      connection_error_hint: 'Мережеве з\'єднання неможливо встановити. Спробуйте перезавантажити сторінку.',
      permission_hint: 'Вам потрібно дозволити цьому веб-сайту використовувати веб-камеру та мікрофон.',
      searching_camera_hint: 'Пошук вебкамери',
      camera_reserved_hint: 'Інша програма або веб-сторінка зарезервувала роботу вашої веб-камери. Будь ласка, закрийте програму та поновіть цю сторінку.',
      camera_reserved_hint_chrome_extra: 'Шановний користувачу Chrome, вам потрібно надати дозвіл Recright на користування вебкамери у діалоговому вікні під адресним рядком.',
      no_camera_hint: 'Вебкамери не знайдено.',
      no_mic_hint: 'Мікрофона не знайдено.',
      uploading_text: 'Завантаження…',
      rtmpt_in_use: 'Цей крок був би не потрібний, якщо ваш адміністратор надав дозвіл на RTMP. Запитати як.',
      preview_text: 'Веб-камера перебуває в режимі попереднього перегляду',
      close_text: 'Завершити роботу вебкамери',
      remove_text: 'Видалити текст',
      noflash_errortext_install: link => `Схоже, у вас немає встановленого програвача Adobe Flash Player. Вам потрібний плагін flash, щоб записувати відео. Завантажте плагін тут: ${link}`,
      noflash_errortext_enable: link => `Якщо ви вже встановили flash, але все ще бачите це повідомлення, подивіться тут: ${link}`,
      noflash_errortext_differentbrowser: 'Крім того, ви можете спробувати за допомогою браузера, який підтримує запис HTML5. Ми пропонуємо Chrome або Firefox.',
    },

    footer: {
      terms: 'Умови',
      license: 'General Terms of Service',
      privacyPolicy: 'Політика конфіденційності',
      customSupport: link => `Зв'яжіться з ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Як би Ви оцінили Вашу співбесіду?',
      howWouldYouRateJobAd: 'Як би ви оцінили свій досвід користування додатком?',
      yourResponseIsAnonymous: 'Ваша відповідь анонімна.',
      thankYouFeedback: 'Дякуємо за відгук!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'На жаль, цей тип файла не дозволяється.',
      isRequired: 'Це поле обов\'язкове для заповнення.',
      isEmail: value => `${value} не є дійсною електронною поштою.`,
      isDate: value => `${value} не є дійсною датою.`,
      invalidUrl: 'URL-адреса недійсна.',
      singleHireEndError: 'Одна вакансія не може бути відкритою більше 60-ти днів.',
      isNotTooOldForLive: 'Дата в минулому.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: "Ім'я",
      city: 'Рідне місто',
      email: 'Електронна пошта',
      phone: 'Телефонний номер',
      applyForPosition: 'Подати заявку на посаду',
      back: 'Назад',
      continue: 'Продовжити',
      submit: 'Відправити',
      saveForLater: 'Продовжити пізніше',
      namePlaceholder: 'Введіть ім\'я',
      emailPlaceholder: 'Введіть електронну пошту',
      phonePlaceholder: 'Введіть телефонний номер',
      cityPlaceholder: 'Введіть місто, в якому ви зараз проживаєте',
      links: 'Додати посилання, наприклад, на профіль в соціальній мережі LinkedIn',
      legendBasicInfo: 'Основна інформація',
      legendLinks: 'Посилання',
      legendAttachments: 'Вкладені файли',
      legendAdditionalFields: 'Додаткова інформація',
      coverLetter: 'Супровідний лист',
      attachments: 'Вкладені файли',
      introduction: 'Напишіть коротке вступне слово тут',
      thankYou: 'Дякуємо.',
      luck: 'Бажаємо успіхів!',
      close: 'Закрити',
      required: 'Пункти, відмічені зірочкою *, є обов\'язковими.',
    },

    jobAdContainer: {
      endTime: date => (date ? `відкрита до ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Відгукнутись на вакансію',
    },

    jobAdQuickInterview: {
      back: 'Назад',
      submit: 'Відправити',
      saveForLater: 'Продовжити пізніше',
      title: 'Експрес відео-співбесіда',
      description: 'Аби познайомитись з вами ближче, ми б хотіли задати вам кілька коротких запитань для нашого експрес-опитування. Покажіть свою індивідуальність та надайте заявці своєї родзинки.',
      requiredNote: 'Зауважте, що це одна частина процесу подання заявки. Рекрутер отримає вашу заявку лише після запису ваших відповідей.',
      reminderNote: 'Ви можете записати відповідь одразу або продовжити пізніше, отримавши нагадування на електронну пошту.',
    },

    jobAdRow: {
      responses: 'Відгуки',
      status: {
        open: 'Відкрито',
        filled: 'Заповнено',
        cancelled: 'Скасовано',
        done: 'Зроблено',
        close: 'Закрити',
        draft: 'Закрито (проект)',
        hidden: 'Сховано',
      },
    },

    interviewRow: {
      responses: 'Кандидати',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Показати профіль LinkedIn',
    },

    linkedInButton: {
      error: 'Помилка при завантаженні профілю. Будь ласка, спробуйте знову',
      buttonText: 'Подати заявку через LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Ви можете використовувати свій профіль LinkedIn для попереднього заповнення форми заявки',
      linkedInOr: 'Або',
      error: 'Помилка при завантаженні профілю. Будь ласка, спробуйте знову',
    },

    linkListInput: {
      addField: 'Додати',
      removeField: 'Видалити',
      invalidUrl: 'URL-адреса недійсна.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
    },

    loadingButton: {
      loading: 'Завантаження…',
      saving: 'Збереження…',
      sending: 'Надсилання…',
    },

    modalApplicationForm: {
      applyForPosition: 'Подати заявку на посаду',
      continue: 'Продовжити',
      name: 'Введіть ім\'я',
      email: 'Введіть електронну пошту',
      phoneNumber: 'Введіть номер телефону',
      links: 'Ви можете ввести посилання',
      legendLinks: 'Посилання',
      legendAttachments: 'Вкладені файли',
      coverLetter: 'Супровідний лист',
      attachments: 'Вкладені файли',
      introduction: 'Напишіть вступне слово тут',
      thankYou: 'Дякуємо.',
      luck: 'Бажаємо успіхів!',
      close: 'Закрити',
    },

    modalConfirm: {
      cancel,
      confirm: 'Гаразд',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Загальнодступне посилання, яке можна поширювати',
      info: 'Це загальнодоступна адреса на вакансію, яку ви можете поширити.\nБудь-хто зацікавлений вакансією зможе побачити її опис та відгукнутись на неї.\nВи отримаєте звичайне сповіщення, коли почнете отримувати відгуки на вакансію.\n\nОсь загальнодоступне посилання на опис вакансії:',
    },

    modalVideoAdd: {
      title: 'Додати нове відео',
      chooseTitle: 'Додати нове відео',
      titlePlaceholder: 'Введіть назву відео тут:',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Завантажити нове відео',
      info: 'Максимально дозволений розмір відео - 500МБ. Ми радимо вам стиснути відео перед його завантаженням. Таким чином, ви скоротите час завантаження і конвертування відео.',
    },

    modalCandidateInfo: [
      {
        headline: 'Запишіть відео-відповідь ',
        content: 'ви можете записати будь-яку кількість відео. Усі відео збережуться одразу після зупинки запису і ви зможете повернутись до відео-співбесіди через посилання, яке ви отримали на електронну пошту.',
        mobileContent: 'ви можете записати будь-яку кількість відео. Додайте відео до співбесіди. Ви побачите завантаження відео та його збереження у співбесіді. Ви зможете повернутись до відео-співбесіди через посилання, яке ви отримали на вашу електронну пошту. <br><br><strong>Якщо ваш відеоекран залишається чорним, і ви використовуєте мобільний пристрій Apple, ви знайдете інструкції щодо вирішення проблеми <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">тут</a>.</strong>',
      },
      {
        headline: 'Після запису, ',
        content: 'переконайтесь, що відео правильно відтворюється, а ваш голос добре чути. Натиснувши на кнопку «Відправити», ваша відповідь заблокується і ви її більше не зможете редагувати.',
      },
      {
        headline: 'Коли ви завершили співбесіду, ',
        content: 'натисніть на кнопку «Відправити відповіді і завершити співбесіду», після чого ви вже не зможете повернутись до відео-співбесіди. Якщо ви бажаєте закрити сторінку і продовжити співбесіду пізніше, натисніть на кнопку «Продовжити пізніше».',
      },
      {
        headline: 'Якщо вам потрібна допомога ',
        content: mailto => `під час відео-співбесіди, натисніть на кнопку «Допомога» справа внизу сторінки або надішліть елетронний листа на ${mailto}.`,
        customContent: link => `Зв'яжіться з ${link}`,
      },
    ],

    navigationBar: {
      back: 'Назад',
      dashboard: 'Особистий кабінет',
      frontpage: 'Головна сторінка',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Телефон у форматi ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Середній рейтинг',
      reset: 'скинути',
    },

    share: {
      share: 'Поділитись в',
      copy: 'Скопіювати посилання',
    },

    sort: {
      sort: 'Сортувати',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Вибрано',
      change: 'Змінити',
    },

    video: {
      videoNotFound: 'Відео обробляється або відео не знайдено',
      retry: 'Спробувати знову',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Завантажити або записати відео' : 'Обрати файл'),
      videoPlaceholder: 'Записати відповідь',
      uploadPlaceholderCandidate: 'Завантажити відео',
      submit: 'Надіслати відповідь',
      notAnswered: 'Ви ще не відповіли',
      remove: 'Видалити відео',
      converting: 'Відео конвертується. Будь ласка, зачекайте…',
      uploading: 'Відео завантажується. Будь ласка, зачекайте…',
      error: {
        invalid: 'Розмір вибраного файлу завеликий. Будь ласка, виберіть інший файл.',
        upload: 'Вибачте, але нам не вдалось завантажити відео. Будь ласка, спробуйте знову.',
        transcode: 'Відеофайл пошкоджений або недійсний. Будь ласка, спробуйте знову.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Показувати більше',
      showLessButtonText: 'Показувати менше',
      infoText1:
        'Утримувати закладку активною на передньому плані під час запису. Жодна інша прикладна програма не повинна використовуватися під час запису.',
      infoText2:
        'Відеозображення для фону відео краще працюють з найновішими браузерами та з відносно новим і потужним пристроєм.',
      infoText3:
        'Переконайтеся, що інші програми не використовують мікрофон або камеру.',
    },

    videoResponse: {
      videoPlaceholder: 'Записати відовідь',
      uploadPlaceholder: 'Завантажити відео',
      submit: 'Відправити відповідь',
      notAnswered: 'Ви ще не дали відповідь',
      startInterview: 'Розпочати співбесіду',
    },

    webcam: {
      useVideoBgButtonText: 'Використовувати фон відео',
      removeVideoBgButtonText: 'Усунути фон відео',
      starting: 'Запуск…',
      close: 'Завершити роботу вебкамери',
      remove: 'Видалити відео',
      record: 'Запис ',
      stop: 'Стоп',
      retake: 'Спробувати ще',
      submit: 'Відправити відповідь',
      converting: 'Відео конвертується. Будь ласка, зачекайте…',
      uploading: 'Відео завантажується. Будь ласка, зачекайте…',
      downloading: 'Відео завантажується. Будь ласка, зачекайте…',
      processing: 'Опрацювання…',
      uploadInProgress: 'Передача відео в процесі, не закривайте браузер і не змінюйте сторінку.',
      uploaded: 'Відео передано.',
      error: {
        DevicesNotFoundError: 'Немає доступу до камери або мікрофона. Перевірте, чи вони ввімкнені.',
        NotFoundError: 'Немає доступу до камери або мікрофона. Перевірте, чи вони ввімкнені.',
        NotAllowedError: 'У вас не було дозволу на використання камери або мікрофона.',
        PermissionDismissedError: 'Ви відхилили діалогове вікно дозволу. Будь ласка, надайте дозвіл на використання камери та мікрофона.',
        PermissionDeniedError: 'Ви відхилили доступ до камери або мікрофона.',
        NotReadableError: 'Неможливо отримати доступ до камери чи мікрофона. Можливо виникла проблема з апаратним забезпеченням.',
        SecurityError: 'Неможливо отримати доступ до камери чи мікрофона через помилку безпеки',
        stream: 'Сталася помилка. Будь ласка, перезапустіть браузер. Якщо проблема не зникне, спробуйте скористатися іншим браузером.',
        download: 'Не вдалося завантажити відео. Спробувати ще раз?',
        upload: 'Не вдалося завантажити відео. Спробувати ще раз?',
        emptyBlob: 'Ваш браузер або пам\'ять пристрою заповнені для створення нового запису. Будь ласка, поновіть сторінку. Якщо це не допоможе, перезапустіть браузер. Якщо у вас все ще є проблема, спробуйте скористатись іншим браузером.',
        alternativeRecorder: 'Файл можна також завантажити, клацнувши це.',
        reconnecting: 'Підключення до мережі перервалося. Ми намагаємося відновити його.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Вітаємо! Хочемо запросити вас на відеоспівбесіду ${title}! Ми також надіслали це запрошення на вашу електронну пошту. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
